import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const couponService = {
  list: (p: { page?: number; limit?: number; search?: string; is_active?: string; discount_type_id?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page??1, limit: p.limit??15 }
    if (p.search) params.search = p.search
    if (p.is_active !== undefined) params.is_active = p.is_active
    if (p.discount_type_id) params.discount_type_id = p.discount_type_id
    return restClient.get(`${endpoints.coupon.list}?${q(params)}`).then(r => r.data)
  },
  createUpdate: (d: Record<string, unknown>) => restClient.post(endpoints.coupon.createUpdate, d).then(r => r.data),
  delete: (id: number) => restClient.delete(`${endpoints.coupon.delete}${id}`).then(r => r.data),
}
